<template>
    <div>
        <div id="root-page" v-if="!selectedSingleClassId">
            <section id="banner" class="bg-secondary">
                <div class="page-banner-pa py-4">
                    <div class="container page-banner-inner-text text-center py-4">
                        <div class="row">
                            <div class="col-12 text-center">
                                <slot name="first-slot"></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="py-3 py-lg-5">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="row align-items-center">
                                <div class="col-md-6 order-2 order-md-1 mb-3">
                                    <div class="text-center text-md-start">
                                        <p class="text-green-dark bold fs-1-3">
                                            <i>MATERIALI</i>
                                        </p>
                                        <h3 class="fs-2-7 mb-3">Salva i materiali sul tuo computer</h3>
                                    </div>
                                    <div class="pe-xxl-5 me-xxl-5">
                                        <p>
                                            Scarica il kit didattico che contiene la <strong>guida docente</strong> e la <strong>scheda attività</strong>.
                                            Il download ti permette di <strong>sbloccare i restanti materiali dell’area riservata</strong>:
                                            le <strong>VIDEO LEZIONI</strong>, 4 contenuti realizzati dal Team <i>Stammi Bene!</i>, e la <strong>SEZIONE CONCORSO</strong>,
                                            per inviare le foto dei contributi e provare a far vincere la tua scuola.<br>
                                            <strong>Ricorda che con questo download partecipi all’estrazione riservata ai docenti: in palio 3 pc portatili!</strong>
                                        </p>
                                        <download-doc-component
                                            v-if="schoolType == 'primaria'"
                                            btn-text="<span>SCARICA IL KIT DIDATTICO</span>"
                                            btn-classes="btn btn-green btn-lg rounded-pill mb-2 px-4"
                                            ajax-action="nl_download_kit"
                                            file-name="Rovagnati_StammiBene_MaterialiDidattici_Primaria.zip"
                                            mime-type="application/zip"
                                            @onCallBack="checkSectionVisibility"
                                        ></download-doc-component>

                                        <download-doc-component
                                            v-if="schoolType == 'secondaria_primo_grado'"
                                            btn-text="<span>SCARICA IL KIT DIDATTICO</span>"
                                            btn-classes="btn btn-green btn-lg rounded-pill mb-2 px-4"
                                            ajax-action="nl_download_kit"
                                            file-name="Rovagnati_StammiBene_MaterialiDidattici_SecondariaPrimoGrado.zip"
                                            mime-type="application/zip"
                                            @onCallBack="checkSectionVisibility"
                                        ></download-doc-component>
                                    </div>
                                </div>
                                <div class="col-md-6 order-1 order-md-2 mb-3" v-html="imgOne" v-if="schoolType == 'primaria'"></div>
                                <div class="col-md-6 order-1 order-md-2 mb-3" v-html="imgOneSecondary" v-else></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="work-info" class="pb-5 pt-4" :class="{'no-click': !parseInt(checkKit)}" @click="checkClick">
                <content-primary-school
                    v-if="schoolType == 'primaria'"
                    :thema-url="themaUrl"
                    :check-kit="checkKit"
                ></content-primary-school>
                <content-secondary-school
                    v-if="schoolType == 'secondaria_primo_grado'"
                    :thema-url="themaUrl"
                    :check-kit="checkKit"
                ></content-secondary-school>
            </section>

            <div id="cls" class="bg-white pt-0 pt-lg-5 pb-0" :class="{'no-click': !parseInt(checkKit)}" @click="checkClick">
                <classes-component
                    :id-teacher="idTeacher"
                    :school-type="schoolType"
                    :thema-url="themaUrl"
                    :check-kit="checkKit"
                    @editSingleClass="editSingleClass"
                ></classes-component>
            </div>

            <div class="container pb-5">
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-11 col-xl-10 col-xxl-8 text-center">
                        <slot name="second-slot"></slot>
                    </div>
                    <div class="col-12 col-lg-11 col-xl-10 col-xxl-8 text-center pt-3">
                        <button class="btn btn btn-green rounded-pill px-4" @click.prevent="goToAttestato" :disabled="downloadDisabled">SCARICA ATTESTATO</button>
                    </div>
                </div>
            </div>
        </div>

        <div id="single-class-page" class="bg-white" v-if="selectedSingleClassId">
            <single-class-component
                :id-class="selectedSingleClassId"
                :class-section="selectedSection"
                :class-class="selectedClass"
                :thema-url="themaUrl"
                :pdf-privacy="pdfPrivacy"
                :doc-liberatoria="docLiberatoria"
                @goBack="goBackToRootPage"
            ></single-class-component>
        </div>

        <v-dialog />
    </div>
</template>

<script>
import axios from 'axios'
import ClassesComponent from './Classes/ClassesComponent.vue'
import SingleClassComponent from './Classes/SingleClassComponent.vue'
import DownloadDocComponent from './DownloadDocComponent.vue'
import ContentPrimarySchool from './ContentPrimarySchool.vue'
import ContentSecondarySchool from './ContentSecondarySchool.vue'

export default {
    props: ['themaUrl', 'siteUrl', 'idTeacher', 'schoolType', 'imgOne', 'imgOneSecondary', 'pdfPrivacy', 'docLiberatoria', 'currentSchoolCredits', 'downloadDisabled'],
    components: {ClassesComponent, SingleClassComponent, DownloadDocComponent, ContentPrimarySchool, ContentSecondarySchool},

    data() {
        return {
            ajaxObj: window.ajax_object,
            msgBlue: 'Non siete ancora in gara! Avete raccolto XX possibilità di essere estratti e vincere, ma potrete partecipare se invierete almeno un contributo obbligatorio.',
            selectedSingleClassId: 0,
            selectedClass: '',
            selectedSection: '',
            schoolCredits: 0,
            playIcon: '<svg class="ms-2" style="width:22px;height:22px;vertical-align:unset;" xmlns="http://www.w3.org/2000/svg" width="33.369" height="33.369" viewBox="0 0 33.369 33.369">\
                        <g id="play" transform="translate(-1092.861 -1299.914)">\
                            <path id="Tracciato_153507" data-name="Tracciato 153507" d="M32.226,14.024a16.064,16.064,0,0,0-.935-3.662,16.625,16.625,0,0,0-1.079-2.256,1.1,1.1,0,0,0-1.449-.391,1.063,1.063,0,0,0-.391,1.449A14.059,14.059,0,1,1,23.2,3.995a1.1,1.1,0,0,0,1.452-.39,1.061,1.061,0,0,0-.388-1.447,16.161,16.161,0,1,0,7.962,11.867" transform="translate(1093.361 1300.414)" stroke="#000" stroke-width="1"/>\
                            <path id="Tracciato_153508" data-name="Tracciato 153508" d="M9.749,5.522a1.661,1.661,0,0,0-1.674-.069,1.614,1.614,0,0,0-.849,1.418v13a1.613,1.613,0,0,0,.849,1.418,1.653,1.653,0,0,0,.78.2,1.632,1.632,0,0,0,.893-.266l9.956-6.5a1.61,1.61,0,0,0,0-2.7Zm8.211,7.807-8.611,5.72L9.321,7.776Z" transform="translate(1097.225 1303.226)" stroke="#000" stroke-width="1"/>\
                        </g></svg>',
            checkKit: 0
        }
    },

    methods: {
        editSingleClass(id, classe, sezione) {
            this.selectedSingleClassId = id
            this.selectedClass = classe
            this.selectedSection = sezione
        },

        goBackToRootPage() {
            this.selectedSingleClassId = 0
            setTimeout(() => {
                let element = document.querySelector("#cls");
                element.scrollIntoView();
            }, 250);

        },

        getSchoolCredits() {
			let url = this.ajaxObj.ajax_url

			axios.get(url,
			{
				params: {
					_nounce_value: this.ajaxObj._nounce_value,
					action: 'nl_get_school_credits',
				}
			})
			.then((response) => {
				// console.log(response.data)
				this.schoolCredits = response.data.credits
			})
			.catch((err) => {
				console.log(err)
			})
        },

        checkSectionVisibility() {
			let url = this.ajaxObj.ajax_url

			axios.get(url,
			{
				params: {
					_nounce_value: this.ajaxObj._nounce_value,
					action: 'nl_check_kit_download'
				}
			})
			.then((response) => {
				// console.log(response.data.kit)
				this.checkKit = parseInt(response.data.kit)
			})
			.catch((err) => {
				console.log(err)
			})
        },

        checkClick(event) {
            if(!this.checkKit) {
                event.preventDefault()
                this.showSectionsDisabledDialog()
            }
        },

        showSectionsDisabledDialog() {
            this.$modal.show('dialog', {
                title: '',
                text: '<div class="text-center"><p class="text-green lh-1-3 fs-1-2 semibold mt-3">SCARICA LE RISORSE EDUCATIVE PER SBLOCCARE IL RESTO DELLA PAGINA E PARTECIPARE.</p></div>',
                buttons: [
                    {
                        title: 'CHIUDI',
                        handler: () => {
                            this.$modal.hide('dialog')
                        }
                    }
                ]
            })
        },

        goToAttestato() {
            window.location.href = this.siteUrl + '/attestato-docenti-e-formazione'
        }
    },

    mounted() {
        this.schoolCredits = this.currentSchoolCredits
        setInterval(() => {
            this.getSchoolCredits()
        }, 10000)
        this.checkSectionVisibility()
    },

    updated() {
        this.checkSectionVisibility()
    }

}
</script>
